import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { store } from "./Store/store";
import { BrowserRouter, HashRouter } from "react-router-dom";

import { createGlobalStyle } from "styled-components";

function AppWrapper() {
  const [apiHost, setApiHost] = useState(null);

  const GlobalStyle = createGlobalStyle`
  /* Font Styles */
  body {
    font-family: 'Ubuntu', sans-serif; /* Replace 'YourFontFamily' with your desired font */
    font-size: 16px; /* Replace 16px with your desired font size */
    font-weight: 400; /* Font weight (e.g., bold: 700, normal: 400, lighter: 300) */
    line-height: 1.6; /* Line height (adjust as needed) */
    color: #333; /* Default font color */
  }

  h1 {
    font-size: 3rem; /* Example heading font size */
    font-weight: 7000; /* Example heading font weight (bold) */
    margin-bottom: 1rem; /* Example heading bottom margin */
  }

  p {
    margin-bottom: 1rem; /* Example paragraph bottom margin */
  }

  /* Additional font styles for specific elements or classes can be added here */
  .your-custom-className {
    font-size: 1.2rem;
    font-style: italic;
    /* Add more custom styles for the className here */
  }
  /* Apply font size to table, th, and td elements within data tables */
  table {
    font-size: 14px; /* Replace 14px with your desired font size for table content */
    /* Add any other styles for tables here if needed */
  }

  TableCell {
    font-size: 100px; /* Replace 16px with your desired font size for table headers */
    /* Add any other styles for table headers here if needed */
  }

  td {
    font-size: 14px; /* Replace 14px with your desired font size for table cells */
    /* Add any other styles for table cells here if needed */
  }
  
`;

  if (window.location.hostname === "localhost") {
    import("./Component/Transport.css").then(() => {
      window.logo = "logo3.png";
      window.profile = "profile1.svg";
      window.firstpage = "TripAeBig.png";
      window.my_domain = "https://api.tripplanner.ae/";
      setApiHost("furasmakkah.com");
    });
    window.firstpage = "FurasBig.png";


  window.getLocalApiQuery = function (url = "") {
    return url.includes("?") ? "&local=api" : "?local=api";
  };




  }

  else if (window.location.hostname === "mobile.furasmakkah.com") {
    import("./Component/Transport.css").then(() => {
      window.logo = "logo3.png";
      window.profile = "profile1.svg";
      window.firstpage = "FurasBig.png";
      window.my_domain = "https://api.tripplanner.ae/";
      setApiHost("furasmakkah.com");
    });
    window.firstpage = "FurasBig.png";

    // comment change in future 
      window.getLocalApiQuery = function () {
    return "";
  };

  //   window.getLocalApiQuery = function (url = "") {
  //   return url.includes("?") ? "&local=api" : "?local=api";
  // };
} 
  
  
  else if (window.location.hostname === "www.mobile.furasmakkah.com") {
    import("./Component/Transport.css").then(() => {
      window.logo = "logo3.png";
      window.profile = "profile1.svg";
      window.firstpage = "FurasBig.png";
      window.my_domain = "https://api.tripplanner.ae/";
      setApiHost("furasmakkah.com");
    });
    window.firstpage = "FurasBig.png";
  //   window.getLocalApiQuery = function (url = "") {
  //   return url.includes("?") ? "&local=api" : "?local=api";
  // };
    window.getLocalApiQuery = function () {
    return "";  };

  }
  else if (window.location.hostname === "mobile.tripplanner.ae") {
    import("./Component/Umrahfuras.css").then(() => {
      window.logo = "logo4.png";
      window.profile = "profile5.png";
      window.firstpage = "TripAeBig.png";
      window.my_domain = "https://api.tripplanner.ae/";
      setApiHost("tripplanner.ae");
    });
    window.firstpage = "TripAeBig.png";
window.getLocalApiQuery = function () {
    return "";
  };


  } else if (window.location.hostname === "mobile.tripplannerpk.com") {
    import("./Component/tripplannerpk.css").then(() => {
      window.logo = "logo6.png";
      window.profile = "profile6.png";
      window.firstpage = "TripPkBig.png";
      window.my_domain = "https://api.tripplanner.ae/";
      setApiHost("tripplanner.ae");
    });
    window.firstpage = "TripPkBig.png";

    window.getLocalApiQuery = function () {
    return "";
  };
  }

  // new code

  localStorage.setItem("MobileApiHost", apiHost);

  return (
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <GlobalStyle />
          {/* <PersistGate loading={null} persistor={persistor}> */}
          <App apiHost={apiHost} />
          {/* </PersistGate> */}
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AppWrapper />);

reportWebVitals();
